import { getApp } from "@firebase/app";
import { getStripePayments, getProducts, createCheckoutSession, onCurrentUserSubscriptionUpdate } from "@invertase/firestore-stripe-payments";
import config from './config'
//import { useNavigate } from "react-router-dom";

const app = getApp();
//const navigate = useNavigate ();

const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "users",
});

export const products = async (type) => {
  const recurring = type == 'recurring' ? true : false;
  //let productList = [];
  
  const products = await getProducts(payments, {
    includePrices: true,
    activeOnly: true,
  });
  const productList = products.filter(product => (recurring ? product.prices[0].type == 'recurring' : product.prices[0].type == 'one_time'))
  /*for(const product of products) {
    if(recurring && )
      productList.push(product)
  }*/
  
  return productList;
}

export const checkout = async(user, product, quantity, projectId = null) => {
  const app_url = config.app_url;
  const sessionParams = {
    price: product.prices[0].id,
    quantity: quantity,
    client_reference_id: user.uid,
    mode: "payment", 
    success_url: projectId
      ? app_url+`/p/${projectId}`
      : app_url+"/storyboards",
  };
  if (projectId) {
    sessionParams.metadata = { projectId: projectId };
  }
  const session = await createCheckoutSession(payments, sessionParams);
  //navigate(session.url);
  return session.url
}


//const updates = () => {}
/*onCurrentUserSubscriptionUpdate(
  payments,
  (snapshot) => {
    for (const change of snapshot.changes) {
      if (change.type === "added") {
        console.log(`New subscription added with ID: ${change.subscription.id}`);
      }
    }
  }
);*/